<div class="view-file">
  <div class="dark-blue">
    <nestas-toolbar [steps]="[]"></nestas-toolbar>
  </div>

  <div class="wrap">

    <mat-tab-group #tabGroup class="mat-tab-group" [(selectedIndex)]="tabindex">

      <mat-tab>

        <ng-template mat-tab-label>
          {{translate.instant('VIEWFILE.FILE_SUMMARY')}}
        </ng-template>


        <mat-card *ngIf="error" align="center">
          <div class="mat-card-wrapper">
            <div mat-card-image>
              <i class="material-icons red">error</i>
            </div>
            <mat-card-title>{{translate.instant(error)}}</mat-card-title>
          </div>
        </mat-card>



        <div *ngIf="file && !error">
          <div class="display-flex">
            <div>
              <mat-card class="file-summary margin-bottom-xl">
                <mat-card-title>{{translate.instant('VIEWFILE.FILE_SUMMARY')}}</mat-card-title>
                <div>
                  <div><span class="highlight">{{translate.instant('DATA.NAME')}}:</span><br />{{file.name}}</div>
                  <br />
                  <div>
                    <span class="highlight">{{translate.instant('DATA.OWNER')}}:</span><br />
                    {{file.PID.PIDOwner.name}}<br />
                  </div>
                  <br />
                  <div><span
                      class="highlight">{{translate.instant('DATA.ADDRESS')}}:</span><br />{{file.PID.address.address}}<br
                      *ngIf="file.PID.address.zip || file.PID.address.city" /> {{file.PID.address.zip}}
                    {{file.PID.address.city}}
                  </div>
                  <br />
                  <div><span class="highlight">{{translate.instant('DATA.JOB')}}:</span><br />{{file.job}}</div>
                  <br />
                  <div><span class="highlight">{{translate.instant('DATA.TYPE')}}:</span><br /> {{file.type}}</div>
                  <br />
                  <div><span class="highlight">{{translate.instant('DATA.ROOM')}}:</span><br /> {{file.room}}</div>
                  <br />
                  <div><span class="highlight">{{translate.instant('DATA.DESCRIPTION')}}:</span><br />
                    {{file.description}}
                  </div>
                  <br />

                  <br />
                </div>

                <mat-card-title>Nestas contact info</mat-card-title>
                <contact></contact>

                <!--<mat-card class="messagebox half-width" style="margin:0;margin-top:10px;" [style.padding]="getMessagePadding()">
                  <div (click)="openMessages = !openMessages" class="cursor">
                    <div *ngIf="!openMessages" class="alert-info alert-info-reverse">
                      <i [title]="translate.instant('DATA.CONTACT_OWNER')" class="material-icons ic-info">message</i>
                      {{translate.instant('DATA.CONTACT_OWNER')}}
                    </div>
                    <div *ngIf="openMessages" class="close-box">
                      <span><i class="material-icons">close</i></span>
                    </div>
                  </div>
                  <div *ngIf="openMessages">
                    <mat-card-subtitle>{{translate.instant('DATA.MESSAGES')}}</mat-card-subtitle>
                    <message [messages]="messages" (send)="sendMessage($event)"></message>
                  </div>
                </mat-card>-->

              </mat-card>
            </div>

            <mat-card class="card-view full-width">
              <div>
                <table class="full-width">
                  <tr class="view-flex">

                    <td *ngIf="fileViewUrls.length > 0" style="border-top:solid 1 px black;">
                      <h3>{{translate.instant('VIEWFILE.FILES')}}</h3>
                    </td>
                    <td *ngIf="fileViewUrls.length">
                      <div *ngFor="let fileViewUrl of fileViewUrls">
                        <preview *ngIf="fileViewUrls" [files]="[fileViewUrl]"></preview>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </mat-card>




          </div>
        </div>

      </mat-tab>

      <mat-tab>

        <ng-template mat-tab-label>
          {{translate.instant('DATA.SHARED_WITH_ME')}}
          <span class="material-icons-badge material-icons-badge-margin"
            *ngIf="linkedfiles && linkedfiles.length > 0">{{linkedfiles.length}}</span>
        </ng-template>

        <nestas-file-table #fileTable *ngIf="table.linkedfiles.all.length" [files]="table.linkedfiles"
          [pending]="table.pending" [onClick]="goToLinkedFile" editable="true" [forContractor]="true"
          [filtered]="false">
        </nestas-file-table>

      </mat-tab>

    </mat-tab-group>
  </div>
</div>